module.exports = __webpack_public_path__ + "media/product/f-6-b9a5bf95.png";